/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
};

export const ExtendTrialButton = ({ onClick }: Props) => (
  <Button color="grey" onClick={onClick}>
    Start Trial
  </Button>
);
